import Notification from '../core/Notification';
import ProjectImport from '../core/project/ProjectImport';
import ProjectProvider from '../core/providers/ProjectProvider';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withGS from '../core/withGShoc';
import VersionWarning from '../core/VersionWarning';

class DataImportContainer extends Component {

  render() {

    const { id, data, baseLink, graph, projectType, components } = this.props;

    if (data.isVersionOfProject) return <VersionWarning/>;
    if (projectType && projectType !== data.type) return <Notification text="You are trying to view an incorrect project type."/>;

    return (
      <ProjectProvider value={data}>
        <ProjectImport
          {...this.props}
          id={id}
          maxRows={1000000}
          disableScreen={true}
          enableSpreadsheet={true}
          enabledImportInto={true}
          handleDuplicates={true}
          existingComponents={[].concat(components)}
          configOptions="dataset"
          allowCounter={true}
          xrefComponents={components}
          baseLink={baseLink}
          project={id}
          graph={graph}
          data={data}
        />
      </ProjectProvider>
    );
  }
}

DataImportContainer.propTypes = {
  subLink: PropTypes.string,
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  components: PropTypes.array,
  projectType: PropTypes.string,
  graph: PropTypes.string.isRequired,
  baseLink: PropTypes.string.isRequired
};

export default withGS(DataImportContainer);